<template>
  <div class='indexbox'>
    <div class="tablebox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="val.shop_name" :name="val.id_tostrign" v-for="val in tablist" :key="val.shop_name">
        </el-tab-pane>
      </el-tabs>
      <div class="draggable" v-loading='loading'>
        <el-table :data="tableData" stripe border>
          <el-table-column prop="name" :label="$t('lg.订单附加属性')" align='center' show-overflow-tooltip>
            <template slot-scope="scope">
              <p>{{name_fun(scope.row.name)}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="value" align='center' show-overflow-tooltip>
            <template slot="header">
              {{$t('lg.平台订单可选字段')}}
              <el-tooltip :content="$t('lg.平台tip')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.value" multiple :placeholder="$t('lg.请选择')" style="width:80%">
                <el-option v-for="item in goodsList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
                <div class="btns">
                  <el-button type="primary" size="small" :loading='btn_loading' @click="lookdata(scope.row)">{{$t('lg.关联')}}</el-button>
                </div>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        activeName: '',
        tablist: [],
        tableData: [],
        loading: false,
        show: false,
        info: {},
        attribute1: false,
        attribute2: false,
        attribute3: false,
        attribute4: false,
        goodsList: [
          { name: this.$t('lg.平台类型'), id: '1' },
          { name: this.$t('lg.买家备注'), id: '2' },
          { name: this.$t('lg.卖家备注'), id: '3' },
          { name: this.$t('lg.买家昵称'), id: '4' },
        ],
        btn_loading: false,
      };
    },
    methods: {
      gettablist() {
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            page: 1,
            page_size: 1000,
            api_id: this.api_id,
          },
          success: (res) => {
            res.data.data.forEach(item => {
              item.id_tostrign = item.id.toString()
            });
            this.tablist = res.data.data
            if (this.tablist.length > 0) {
              if (sessionStorage.getItem("order_attribute_activeName")) {
                this.activeName = sessionStorage.getItem("order_attribute_activeName")
              } else {
                this.activeName = res.data.data[0].id_tostrign
              }
            } else {
              sessionStorage.removeItem('order_attribute_activeName')
            }

            this.$nextTick(() => {
              this.getlist()
            })
          },
          tip: () => {
          },
        })
      },
      handleClick(tab) {
        this.activeName = tab.name
        sessionStorage.setItem("order_attribute_activeName", tab.name)
        this.pagechage(1)
      },
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/order_attribute/attributeList",
          data: {
            shop_id: this.activeName
          },
          success: (res) => {
            this.info = res.data
            if (JSON.stringify(res.data) != '{}') {
              let obj = JSON.parse(JSON.stringify(res.data))
              let arr = []
              for (let i in obj) {
                if (i.indexOf('attribute') !== -1) {
                  let arr1 = obj[i] ? obj[i].split(',') : null
                  arr.push({
                    name: i,
                    value: arr1 ? arr1 : null,
                  })
                }
              }
              this.tableData = arr
            }
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.tableData = []
            this.loading = false
          },
        })
      },
      pagechage() {
        this.tableData = []
        this.getlist()
      },
      name_fun(data) {
        if (data) {
          return data.replace('attribute', this.$t('lg.附加属性'))
        }
      },
      value_fun(data) {
        let obj = { 1: this.$t('lg.平台类型'), 2: this.$t('lg.买家备注'), 3: this.$t('lg.卖家备注'), 4: this.$t('lg.买家昵称') }
        if (data) {
          let tit = []
          let arr = data.split(',')
          arr.forEach(item => {
            tit.push(obj[item])
          })
          return tit.join()
        }
      },
      // 关联数据
      lookdata(row) {
        let data = {
          id: this.info.id,
        }
        data[row.name] = row.value.join();
        this.btn_loading = true
        this.$post({
          url: "/app/order_attribute/edit",
          data,
          success: res => {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.show = false
              this.pagechage(this.page)
              this.btn_loading = false
            }, 1500);
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loading = false
            }, 1500);
          },
        })
      },
      // 关联
      onSubmit() {
        let arr = []
        let data = {
          id: this.info.id,
        }
        if (this.attribute1) {
          arr.push(1)
        }
        if (this.attribute2) {
          arr.push(2)
        }
        if (this.attribute3) {
          arr.push(3)
        }
        if (this.attribute4) {
          arr.push(4)
        }
        data[this.id] = arr.join()
        this.btn_loading = true
        this.$post({
          url: "/app/order_attribute/edit",
          data,
          success: res => {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.show = false
              this.pagechage(this.page)
              this.btn_loading = false
            }, 1500);
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loading = false
            }, 1500);
          },
        })
      },
    },
    created() {
      this.gettablist()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .tablebox {
      width: 100%;
      padding: 20px;
      /deep/.el-tabs__nav-wrap::after {
        display: none;
      }
    }
    .formbox {
      > div {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border: 1px solid #babdcd;
        margin-bottom: 20px;
        border-radius: 5px;
        p {
          color: #3b3b3b;
          font-size: 14px;
          font-weight: 550;
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
      /deep/.el-button {
        width: 100%;
        height: 48px;
        background: $color;
        border-radius: 5px;
        border-color: $color;
      }
    }
  }
</style>